<section class="product-preview">
  <!-- product images & videos -->
  <div class="product-preview__media">
    <!-- main image and options menu -->
    <div class="product-preview__media-container">
      <!-- media gallery -->
      <pwj-gallery
        [mediaData]="previewData()?.media || []"
        [mediaListCount]="3"
        [isColumnListMode]="true"
        previewWidth="424"
        previewHeight="424"
        previewWidthClass="!w-424 !max-w-424"
        previewHeightClass="!h-424"
        [previewAlt]="
          (previewData()?.title | translateData) || 'product'
        "></pwj-gallery>
    </div>
  </div>
  <!-- product details content -->
  <div class="product-preview__content">
    <div class="product-title">
      <pwj-card-title [cardTitleData]="productPreviewTitle"></pwj-card-title>
      @if (previewData()?.specialist_verified) {
        <img
          class="product-title__icon"
          ngSrc="assets/icons/golden-verify.svg"
          width="54"
          height="54"
          alt="verify" />
      }
    </div>
    <!-- product description -->
    <div class="product-description">
      <p class="product-description__text">
        {{ (previewData()?.description | translateData)?.slice(0, 140) }}
        @if (previewData()?.description &&
        ((previewData()?.description | translateData) || '').length > 140) {
          <span class="more-btn" (click)="goToDescription()">{{
              'global.more' | translate
            }}</span>
        }
      </p>
    </div>
    <!-- product properties -->
    <div class="product-properties">
      @for (property of productProperties; track property.name) {
        @if (property.value) {
          <pwj-card-property [cardPropertyData]="property"></pwj-card-property>
        }
      }
    </div>
    <!-- product details bottom -->
    <div class="details-options">
      <!-- price section -->
      <div class="details-options__price">
        <!-- label -->
        <p class="price-label">{{ 'global.price' | translate }}</p>
        <!-- price value -->
        <pwj-item-prices
          [highestPrice]="previewData()?.highest_price"
          [lowestPrice]="previewData()?.lowest_price"></pwj-item-prices>
      </div>
      <!-- contact and request buttons -->
      <div class="details-options__btns">
        <pwj-button
          variant="secondary"
          size="large"
          icon="chevron-right"
          matomoClickCategory="Contact"
          matomoClickAction="View"
          matomoClickName="Product Details"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          (click)="contactUs()"
        >{{ 'global.contact' | translate }}
        </pwj-button
        >

        <!-- submit button -->
        @if (isUserLoggedIn) {
          <div>
            <pwj-button
              [variant]="!userName ? 'secondary' : 'primary'"
              size="large"
              icon="chevron-right"
              matomoClickCategory="Product"
              matomoClickAction="Request"
              matomoClickName="Product Details"
              [rotateIconInRtl]="true"
              [iconReversePosition]="true"
              (click)="submitARequest()"
              [class.pointer-events-none]="!userName"
              [disabled]="!userName"
            >{{ 'global.submitARequest' | translate }}
            </pwj-button
            >
          </div>
        } @else {
          <div>
            <pwj-register-button title="global.submitARequest"
                                 size="large"
                                 matomoClickCategory="Authentication"
                                 matomoClickAction="Login-Register"
                                 matomoClickName="Product Details"></pwj-register-button>
          </div>
        }
      </div>
    </div>
  </div>
</section>
